import React, { useState } from "react"
import { MobileStyles } from "../../styles/index"
import { css } from '../../page-helpers/aphrodite-export';
import { Link as GatsbyLink } from "gatsby"
import LogoImg from '../../assets/images/logo.png';
import MenuIcn from '../../assets/images/menu-icon.png';

export default () => {
    const [isMenuOpen, setMenuState] = useState(false);

    const toggleMenu = () => {
        setMenuState(!isMenuOpen);
    }

    return (
        <div className={css(MobileStyles.headerCtn)}>
            <div className={css(MobileStyles.headerMenuLogo)}>
                <GatsbyLink
                    to={"/"}
                >
                    <img alt='Logo' src={LogoImg} className={css(MobileStyles.headerMenuLogoImg)} />
                </GatsbyLink>
            </div>
            <div
                className={css(MobileStyles.headerMenuBtn)}
                onClick={toggleMenu}
            >
                <img alt='Menu' src={MenuIcn} style={{ width: '20px' }} />
            </div>
            <div
                className={css(
                    MobileStyles.headerMenuCtn,
                    isMenuOpen ? MobileStyles.headerMenuCtnOpen : ""
                )}
            >
                <GatsbyLink
                    to={"/"}
                    activeClassName={css(
                        MobileStyles.headerMenuItem,
                        MobileStyles.headerMenuItemActive
                    )}
                    className={css(MobileStyles.headerMenuItem)}
                    onClick={toggleMenu}
                >
                    Home
                </GatsbyLink>
                <GatsbyLink
                    to={"/about"}
                    activeClassName={css(
                        MobileStyles.headerMenuItem,
                        MobileStyles.headerMenuItemActive
                    )}
                    className={css(MobileStyles.headerMenuItem)}
                    onClick={toggleMenu}
                >
                    About
                </GatsbyLink>
                {/**<GatsbyLink
                    to={"/ewastecollection"}
                    activeClassName={css(
                        MobileStyles.headerMenuItem,
                        MobileStyles.headerMenuItemActive
                    )}
                    className={css(MobileStyles.headerMenuItem)}
                    onClick={toggleMenu}
                >
                    E-Waste Collection Center
                </GatsbyLink>**/}
                <GatsbyLink
                    to={"/products"}
                    activeClassName={css(
                        MobileStyles.headerMenuItem,
                        MobileStyles.headerMenuItemActive
                    )}
                    className={css(MobileStyles.headerMenuItem)}
                    onClick={toggleMenu}
                >
                    Products
                </GatsbyLink>
	    {/**
                <a
                    href="https://blog.keus.in/"
                    target="_blank"
                    className={css(MobileStyles.headerMenuItem)}
                >
                    Blog
                </a>
		**/}
                <a
                    href="https://smarthome.keus.in/schedule-demo/"
                    target="_blank"
                    className={css(MobileStyles.headerMenuItem)}
                >
                    Schedule Demo
                </a>
                {/**<GatsbyLink
                    to={"/scheduledemo"}
                    activeClassName={css(
                        MobileStyles.headerMenuItem,
                        MobileStyles.headerMenuItemActive
                    )}
                    className={css(MobileStyles.headerMenuItem)}
                    onClick={toggleMenu}
                >
                    Schedule Demo
                    </GatsbyLink>**/}
                <GatsbyLink
                    to={"/contactus"}
                    activeClassName={css(
                        MobileStyles.headerMenuItem,
                        MobileStyles.headerMenuItemActive
                    )}
                    className={css(MobileStyles.headerMenuItem)}
                    onClick={toggleMenu}
                >
                    Contact Us
                </GatsbyLink>
            </div>
        </div>
    );
}
